import api from "../../../utils/api";

export const getProgramTypes = async () => {
  return (await api.get("/Academics/GetAllProgramTypesAsync"))
    // eslint-disable-next-line no-undef
    ?.data as ProgramTypeResponse;
};

export const getProgram = async () => {
  return (await api.get("/Utilities/GetAllProgramDetails"))
    // eslint-disable-next-line no-undef
    ?.data as ProgramTypeResponse;
};
